import styles from "./ExpenseSection.module.css";
import { Grid } from "@mui/material";
import ExpensesLogo from "./ExpensesLogo";
import ExpensesTracking from "./ExpensesTracking";
import Container from '@mui/material/Container';
function ExpenseSection() {
  return (
    <>
    <Container maxWidth="xl">
       <Grid container spacing={3} className={styles.expenseSection_mainWrap}>
        <Grid item  xs={12} md={12} lg={6}  sm={12}  order={{ xs: 2, md: 2, lg: 1 }} className={styles.expensesLogo}>
          <ExpensesLogo />
        </Grid>
        <Grid item  xs={12} md={12} lg={6}  sm={12} order={{ xs: 1, md: 1, lg: 2  }} className={styles.trackExpensesSection}>
          <ExpensesTracking />
        </Grid>
      </Grid>
    </Container>
    </>
  )
}

export default ExpenseSection
